import { Button, Flex, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import React from 'react';

function InterviewSearchBar({ setQuerySearch, handleApplySearch }) {
  return (
    <Flex mr='20px'>
      <InputGroup display='flex' alignItems='center'>
        <Input
          fontSize='14px'
          placeholder='Search by text'
          size='sm'
          h='48px'
          w='250px'
          borderRadius='48px'
          backgroundColor='white'
          onChange={e => setQuerySearch(e.target.value)}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              handleApplySearch();
            }
          }}
        />

        <InputRightElement top='unset' w='87px'>
          <Button colorScheme='blue' w='87px' h='48px' size='sm' onClick={handleApplySearch}>
            GO
          </Button>
        </InputRightElement>
      </InputGroup>
    </Flex>
  );
}

export default InterviewSearchBar;
